import React, { useState, useEffect } from "react";
import "../styles/home.css";
import ImgPay from "../assets/images/pay-sm.png"
import ImgStipends from "../assets/images/stipends-sm.png"
import ImgContracts from "../assets/images/contracts-sm.png"
import axios from "axios";




export default function App() {
  const [sticky, setSticky] = useState(false);
   const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);

    const fetchTerms = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL +"/get-privacy-policy");
        // const response = await axios.get("https://api.roampays.com/get-privacy-policy");
       
        // Adjust 'response.data.privacy_policy' based on your exact API structure
        setContent(response.data.privacy_policy);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching privacy policy   :", err);
        setError("Failed to load Privacy Policy. Please try again later.");
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  useEffect(() => {
    const root = document.getElementById("root");
    root.classList.add("home-root");
    root.style.flexGrow = "1";

    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const [activeMenu, setActiveMenu] = useState(0);

  const images = [ImgPay, ImgStipends, ImgContracts];
  const texts = [
    <>
      <span>Enter contract details</span> (pay rate, stipends, reimbursements, etc.)
    </>,
    <>
      <span>Review your per diem breakdown</span> and estimated take-home income
    </>,
    <>
      <span>Compare contracts</span> before signing
    </>
  ];

  // Auto-change every 15 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveMenu((prev) => (prev + 1) % images.length);
    }, 5000); // 15 seconds

    return () => clearInterval(interval);
  }, [images.length]);


  return (
    <div className="home-page">
      {/* Navbar */}
      <header className={`navbar ${sticky ? "sticky" : ""}`}>
        <div className="nav-container">
          <div className="nav-left">
            <a href="/" className="logo">Roam</a>
            <nav>
              <a href="#features" className="fs-14 color-low">Features</a>
              <a href="#resources" className="fs-14 color-low">Resources</a>
              <a href="#faqs" className="fs-14 color-low">FAQs</a>
              <a href="#pricing" className="fs-14 color-low" >Pricing</a>
            </nav>
          </div>
          <div className="nav-right">
            <a href="/login" className="btn-transparent" target="_blank">Login</a>
            <a href="/register" className="btn-white" target="_blank">Sign Up</a>
          </div>
        </div>
      </header>

      {/* Section 1 */}
      <section className="section section-features">

        
        <div className="container top">

        {loading ? (
              <div className="color-white fs-24 align-center">Loading...</div>
            ) : error ? (
              <div className="color-secondary fs-18 align-center">{error}</div>
            ) : (
              <div className="terms-content">
                <div 
                  className="color-secondary fs-16 line-height-1-5"
                  dangerouslySetInnerHTML={{ __html: content }} 
                />
              </div>
            )}

        </div>
      </section>









      {/* Footer */}


      <footer className="footer " id="contact">
        <div className="container footer-grid">

          <div className="footer-left flex-grow-1">
            <div className="footer-brand ">
              <a href="/" className="logo">Roam</a>

              <p className="color-secondary fs-16">
                Per Diem Calculator for <br /> Travel Healthcare Professionals
              </p>

              <div className="social-icons">
                <a href="#" title="Dribble">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3569 21.2708C19.8824 19.6656 21.6391 16.9587 21.9505 13.8265C19.3663 13.8357 17.4497 13.9085 15.557 14.4783C16.3697 16.5938 16.9709 18.8301 17.3569 21.2708ZM13.6949 15.2082C11.6566 16.1964 9.37679 17.923 6.24199 21.0021C7.86997 22.1506 9.8562 22.8252 12 22.8252C13.2216 22.8252 14.3921 22.6061 15.4743 22.2052C15.1192 19.675 14.5276 17.3787 13.6949 15.2082ZM14.7783 12.626C17.0449 11.9078 19.276 11.8336 21.9507 11.826C21.7731 10.0355 21.1232 8.38385 20.1273 6.99746C18.1435 8.53194 16.1205 9.77561 13.8293 10.7132C14.1665 11.343 14.4829 11.9797 14.7783 12.626ZM11.9271 11.4C12.2809 12.0474 12.6105 12.7008 12.9162 13.3635C10.5333 14.4996 8.01868 16.4408 4.72628 19.6877C3.0361 17.8968 2 15.482 2 12.8252L2 12.8168C5.92271 12.7502 9.12157 12.2843 11.9271 11.4ZM12.8277 8.96034C14.9834 8.10829 16.8941 6.95835 18.8014 5.49428C17.0169 3.83795 14.6267 2.8252 12 2.8252C10.8851 2.8252 9.81273 3.00766 8.81125 3.34436C10.3405 5.2239 11.6804 7.07118 12.8277 8.96034ZM6.92979 4.20401C8.44524 6.03834 9.76388 7.82028 10.889 9.62555C8.46507 10.3377 5.66455 10.7384 2.20261 10.8126C2.77743 7.99949 4.53338 5.61641 6.92979 4.20401Z" fill="#A2ABB8" />
                  </svg>
                </a>
                <a href="#" Title="X">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path d="M9.08612 15.5389C8.89301 15.2915 8.52236 15.2811 8.31569 15.5173L4.24744 20.1667C3.88375 20.5823 3.92587 21.2141 4.34151 21.5778C4.75715 21.9415 5.38891 21.8993 5.75259 21.4837L9.69475 16.9784C9.85271 16.7979 9.86021 16.5306 9.71261 16.3415L9.08612 15.5389Z" fill="#A2ABB8" />
                    <path d="M15.6897 10.127C15.483 10.3632 15.1124 10.3528 14.9193 10.1054L14.2928 9.30279C14.1452 9.11369 14.1527 8.84642 14.3107 8.66588L18.2474 4.1667C18.6111 3.75107 19.2429 3.70895 19.6585 4.07263C20.0742 4.43631 20.1163 5.06808 19.7526 5.48371L15.6897 10.127Z" fill="#A2ABB8" />
                    <path d="M20.8999 21.0175L7.78057 4.20989C7.59106 3.96711 7.30026 3.8252 6.99228 3.8252H3.50483C3.08836 3.8252 2.85443 4.30455 3.11069 4.63285L16.23 21.4405C16.4195 21.6833 16.7103 21.8252 17.0183 21.8252H20.5057C20.9222 21.8252 21.1561 21.3458 20.8999 21.0175Z" fill="#A2ABB8" />
                  </svg>
                </a>
                <a href="#" title="Youtube">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.58971 5.03461C3.72849 5.16074 2.29215 6.64213 2.1711 8.50369C2.08072 9.89371 2 11.5048 2 12.8252C2 14.1456 2.08072 15.7567 2.1711 17.1467C2.29215 19.0083 3.72849 20.4896 5.58971 20.6158C7.21433 20.7259 9.40027 20.8252 12 20.8252C14.5997 20.8252 16.7857 20.7259 18.4103 20.6158C20.2715 20.4896 21.7078 19.0083 21.8289 17.1467C21.9193 15.7567 22 14.1456 22 12.8252C22 11.5048 21.9193 9.89371 21.8289 8.50369C21.7078 6.64213 20.2715 5.16074 18.4103 5.03461C16.7857 4.92451 14.5997 4.8252 12 4.8252C9.40027 4.8252 7.21433 4.92451 5.58971 5.03461ZM11.5521 9.99299C10.8873 9.55284 10 10.0295 10 10.8268V14.8239C10 15.6211 10.8873 16.0978 11.552 15.6577L14.5454 13.6759C15.1546 13.2726 15.1547 12.3783 14.5455 11.975L11.5521 9.99299Z" fill="#A2ABB8" />
                  </svg>
                </a>
                <a href="#" title="Messenger">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.8252C17.5228 22.8252 22 18.348 22 12.8252C22 7.30235 17.5228 2.8252 12 2.8252C6.47715 2.8252 2 7.30235 2 12.8252C2 15.0764 2.74389 17.1539 3.99927 18.8252L3.99977 21.596C3.99989 22.2301 4.58261 22.704 5.20344 22.5749L8 21.9931C9.22492 22.5283 10.5778 22.8252 12 22.8252ZM6.70509 14.5322L9.45568 10.6028C9.76078 10.1669 10.3537 10.0463 10.8049 10.3283L13.4525 11.983C13.7858 12.1913 14.2102 12.1851 14.5372 11.9671L16.7092 10.519C16.8783 10.4063 17.1034 10.4286 17.2471 10.5723C17.3934 10.7186 17.4135 10.9487 17.2949 11.1182L14.5443 15.0476C14.2392 15.4835 13.6463 15.6041 13.1951 15.3221L10.5475 13.6674C10.2142 13.4591 9.78981 13.4653 9.4628 13.6833L7.29077 15.1313C7.1217 15.2441 6.89657 15.2218 6.75289 15.0781C6.60663 14.9318 6.58647 14.7017 6.70509 14.5322Z" fill="#A2ABB8" />
                  </svg>
                </a>
              </div>
            </div>

           <div className="footer-contact color-secondary">
  <div className="fs-18">
    Roam Pays App LLC
  </div>
  <a href="mailto:eric@roampays.com" className="color-secondary fs-16 line-height-1" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight: '8px', verticalAlign: 'middle'}}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
     eric@roampays.com
  </a>

  <a href="tel:+17014047593" className="color-secondary fs-16 line-height-1" target="_blank">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight: '8px', verticalAlign: 'middle'}}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
     (701) 404-7593
  </a>
  <div className="fs-16 line-height-1">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight: '8px', verticalAlign: 'middle'}}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
    3003 32ND Ave S Ste 240,Fargo, ND 58103-6118
  </div>
</div>
          </div>


          <div className="footer-links">
            <div>
              <h6>Links</h6>
              <a href="#features" className="fs-14 color-secondary">Features</a>
              <a href="#resources" className="fs-14 color-secondary">Resources</a>
            </div>
            <div>
              <h6>Company</h6>
              <a href="#about" className="fs-14 color-secondary">About</a>
              <a href="#contact" className="fs-14 color-secondary">Contact</a>
            </div>
            <div>
              <h6>Support</h6>
              <a href="#help" className="fs-14 color-secondary">Help Center</a>
              <a href="#terms" className="fs-14 color-secondary">Terms</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom fs-14 fs-helvetica-neue">

          <div className="footer-bottom-left">
            <a href="/terms" className="color-secondary">Terms & Conditions</a>
            <a href="/privacy" className="color-secondary">Privacy Policy</a>
          </div>

          <div className="footer-bottom-right color-secondary">
            Copyright © {new Date().getFullYear()} | Roam. All rights reserved.
          </div>

        </div>
      </footer>
    </div>
  );
}

